import {useTranslation} from 'react-i18next'
import {FiltrosDeEstado, type OpcionEstado} from '@/components/ui/filtros-de-estado'

export type FiltroPropuestas = 'pendientes' | 'resueltos' | 'todos'

/** Filtra en el servidor (`?pendiente=`); `propuestas-resumen` es el ancla que miran las tomas de demo. */
export function PerfilesCargoFiltro({
  filtro,
  onFiltro,
  pendientes,
  total,
}: {
  filtro: FiltroPropuestas
  onFiltro: (filtro: FiltroPropuestas) => void
  pendientes: number
  total: number
}) {
  const {t} = useTranslation()
  // Claves literales y no por plantilla: el gate `i18n-keys` solo ve las literales.
  const opciones: OpcionEstado<FiltroPropuestas>[] = [
    {valor: 'pendientes', etiqueta: t('perfilCargo.filtro.pendientes'), conteo: pendientes},
    {valor: 'resueltos', etiqueta: t('perfilCargo.filtro.resueltos'), conteo: total - pendientes},
    {valor: 'todos', etiqueta: t('perfilCargo.filtro.todos'), conteo: total},
  ]
  return (
    <div data-testid="propuestas-resumen">
      <FiltrosDeEstado opciones={opciones} valor={filtro} onValor={onFiltro} testIdPrefijo="filtro" />
    </div>
  )
}

export type FiltroEstado = 'todos' | 'sin_perfil' | 'borrador' | 'confirmado'

/** Filtra en el backend (`GET …/perfiles-cargo?estado=`). */
export function PerfilesCargoEstadoFiltro({
  estado,
  onEstado,
}: {
  estado: FiltroEstado
  onEstado: (estado: FiltroEstado) => void
}) {
  const {t} = useTranslation()
  const opciones: OpcionEstado<FiltroEstado>[] = [
    {valor: 'todos', etiqueta: t('perfilCargo.filtro.todos')},
    {valor: 'sin_perfil', etiqueta: t('perfilCargo.estado.sin_perfil')},
    {valor: 'borrador', etiqueta: t('perfilCargo.estado.borrador')},
    {valor: 'confirmado', etiqueta: t('perfilCargo.estado.confirmado')},
  ]
  return <FiltrosDeEstado opciones={opciones} valor={estado} onValor={onEstado} testIdPrefijo="filtro-estado" />
}
